function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewIconsWinecupIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 135 135",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M67.5,132.25c35.732,0,64.75-29.018,64.75-64.75S103.232,2.75,67.5,2.75,2.75,31.768,2.75,67.5s29.018,64.75,64.75,64.75Z",
    style: {
      fill: "#00aa6c",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7627,23.4609H42.2373v22.0764c0,6.714,2.6173,13.0866,7.3967,17.866,4.7794,4.7794,11.152,7.3967,17.866,7.3967s13.0866-2.6173,17.866-7.3967c4.7794-4.7794,7.3967-11.152,7.3967-17.866V23.4609Z",
    style: {
      fill: "#00aa6c",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5,70.8001v40.739",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1314,111.5391h-25.2627",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7627,44.8546c-9.2175-1.0242-18.2074-3.9829-27.3111-5.9174-7.5105-1.7069-15.5901-2.6173-23.1006-1.3656v7.9657c0,6.714,2.6173,13.0866,7.3967,17.866,4.7794,4.7794,11.152,7.3967,17.866,7.3967s13.0866-2.6173,17.866-7.3967,7.3967-11.152,7.3967-17.866l-.1138-.6828h0Z",
    style: {
      fill: "#00aa6c",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewIconsWinecupIcon);
export default __webpack_public_path__ + "static/media/new-icons_winecup-icon.ea2e86c9cae2885e66437344ae039814.svg";
export { ForwardRef as ReactComponent };